/**
 * Reservation triggers
 *
 * Makes the mobile menu button, and any in-page button wrapped in
 * `.reservation-trigger`, open the same reservation flow as the header
 * "Book a Table" button (Sevenrooms widget or external booking link).
 *
 * @package EVT Restaurant Builder
 * @since 1.0.0
 */

export function initReservationTrigger() {
    const mainTrigger = document.getElementById('sr-res-root');
    const mobileTrigger = document.getElementById('sr-res-root-mobile');

    if (mainTrigger && mobileTrigger) {
        mobileTrigger.addEventListener('click', (e) => {
            e.preventDefault();

            // Close mobile menu first
            const mobileMenu = document.querySelector('[data-mobile-menu]');
            if (mobileMenu && mobileMenu.classList.contains('is-open')) {
                mobileMenu.classList.remove('is-open');
                document.body.classList.remove('mobile-menu-open');
            }

            // Trigger the main reservation button
            mainTrigger.click();
        });
    }

    initInPageReservationTriggers(mainTrigger);
}

/**
 * Route in-page `.reservation-trigger` buttons to the header booking flow.
 *
 * @param {HTMLElement|null} mainTrigger Sevenrooms widget trigger, if present.
 */
function initInPageReservationTriggers(mainTrigger) {
    const externalLink = document.querySelector('.site-header .btn-external .wp-block-button__link');

    document.querySelectorAll('.reservation-trigger .wp-block-button__link, a.reservation-trigger').forEach((link) => {
        if (mainTrigger) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                mainTrigger.click();
            });
        } else if (externalLink) {
            link.setAttribute('href', externalLink.getAttribute('href'));
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener');
        }
    });
}
